import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetempletourcab() {



  const cardData = {
"keyword": "Pune Temple Tour Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune Temple Tour Cab for devotees and travelers who want to explore the most famous spiritual destinations of Pune in a convenient and peaceful way. Whether you are planning a half-day temple visit, full-day religious tour, family pilgrimage, senior citizen-friendly darshan, or spiritual city exploration, our cab service ensures a smooth and stress-free journey. With experienced drivers who understand Pune’s temple routes and traffic conditions, clean air-conditioned vehicles maintained for comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience across the city. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible customized itineraries, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and divine temple tour experience in Pune.",

"topPlaces": [
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description":
      "Dagdusheth Halwai Ganpati Temple is one of the most famous and revered temples in Pune dedicated to Lord Ganesha. It attracts thousands of devotees daily and is known for its grand celebrations during Ganesh Chaturthi and its spiritual atmosphere."
  },
  {
    "title": "Chaturshringi Temple",
    "description":
      "Chaturshringi Temple is a popular hilltop temple dedicated to Goddess Chaturshringi. Located on Senapati Bapat Road, it offers a peaceful spiritual environment and is especially crowded during Navratri festival."
  },
  {
    "title": "Parvati Hill Temple",
    "description":
      "Parvati Hill Temple is a historic temple complex located on a hill offering panoramic views of Pune city. It includes ancient temples dedicated to Lord Shiva, Ganesha, and other deities, making it a key spiritual attraction."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description":
      "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved out of a single basalt rock in the 8th century. It is located in the heart of Pune and is a unique heritage temple site."
  },
  {
    "title": "Sarasbaug Ganpati Temple",
    "description":
      "Sarasbaug Ganpati Temple is a peaceful temple located inside a beautiful garden. It is a popular spiritual and leisure spot for devotees and families visiting Pune."
  },
  {
    "title": "ISKCON NVCC Temple",
    "description":
      "ISKCON NVCC Temple is a modern spiritual center dedicated to Lord Krishna, known for its peaceful environment, devotional activities, and beautiful architecture in Kondhwa area."
  },
  {
    "title": "Omkareshwar Temple",
    "description":
      "Omkareshwar Temple is a historic Shiva temple located near Shaniwar Wada. It is an important religious site with strong cultural and spiritual significance in Pune."
  },
  {
    "title": "ISKCON Pune Camp",
    "description":
      "ISKCON Pune Camp is a serene temple offering spiritual programs, kirtans, and meditation sessions. It is a peaceful retreat for devotees in the city."
  },
  {
    "title": "Baneshwar Temple",
    "description":
      "Baneshwar Temple is located on the outskirts of Pune and is surrounded by natural forest and waterfalls, offering a calm and devotional experience."
  },
  {
    "title": "Pune Spiritual Circuit Route",
    "description":
      "The Pune Temple Tour Cab covers a mix of ancient temples, modern spiritual centers, hilltop shrines, and heritage religious sites, offering a complete devotional experience across the city in a single comfortable journey."
  }
],



services: [
  {
    name: "Pune Temple Tour Cab",
    description: "Pune temple tour cab service provides reliable transportation for devotees and travelers visiting famous temples and spiritual destinations around Pune. Comfortable vehicles with experienced drivers ensure smooth travel for families, pilgrims, tourists, and senior citizens. Pickup services are available from homes, hotels, railway stations, airport terminals, and offices across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different pilgrimage travel requirements. Flexible booking options allow convenient temple tour cab reservations."
  },
  {
    name: "Pune Religious Tour Taxi",
    description: "Pune religious tour taxi service offers dependable transportation for spiritual tours and temple visits across Pune with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for religious tourism, family darshan trips, and group pilgrimage tours. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient religious tour taxi reservations."
  },
  {
    name: "Pune Temple Darshan Cab",
    description: "Pune temple darshan cab service provides comfortable transportation for devotees visiting temples, pilgrimage centers, and spiritual attractions around Pune. Vehicles ensure reliable local and highway travel with experienced chauffeurs offering safe and smooth journeys across temple routes. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune. Ideal for one-day and multi-day pilgrimage travel requirements. Flexible booking options allow convenient temple darshan cab reservations."
  },
  {
    name: "Pune Spiritual Tour Cab",
    description: "Pune spiritual tour cab service offers reliable transportation with comfortable vehicles and professional drivers for spiritual journeys and religious sightseeing around Pune. Vehicles provide smooth city and highway travel suitable for temple tourism, family darshan trips, and cultural visits. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy spiritual tour cab reservations."
  },
  {
    name: "Pune Temple Sightseeing Taxi",
    description: "Pune temple sightseeing taxi service provides dependable transportation solutions for passengers traveling to temples and sacred attractions around Pune. Vehicles are suitable for city and long-distance temple travel ensuring safe and smooth journeys for individuals, families, and groups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for spiritual travel, darshan tours, and temple visits. Flexible booking options allow convenient temple sightseeing taxi reservations."
  },
  {
    name: "Best Pune Temple Cab",
    description: "Best Pune temple cab service provides transparent and reliable transportation for devotees planning comfortable temple tours and spiritual journeys from Pune. Travelers can enjoy peaceful journeys with experienced drivers familiar with temple routes and pilgrimage destinations. Comfortable vehicles ensure smooth travel with safe transportation services throughout the tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient temple cab reservations."
  },
  {
    name: "Cheap Pune Temple Taxi",
    description: "Cheap Pune temple taxi service provides economical and comfortable transportation for families and devotees planning temple tours from Pune. Vehicles ensure smooth city and highway travel suitable for pilgrimage tourism, family darshan trips, and group travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow affordable temple taxi reservations."
  },
  {
    name: "SUV Pune Temple Tour Cab",
    description: "SUV Pune temple tour cab service offers spacious transportation for families and groups planning temple visits and spiritual tours from Pune. SUV vehicles provide comfortable seating, smooth ride quality, and luggage space suitable for long-distance religious travel. Professional drivers ensure safe and reliable transportation services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient SUV temple cab reservations."
  },
  {
    name: "Innova Pune Temple Cab",
    description: "Innova Pune temple cab service allows passengers to reserve premium SUV transportation for comfortable temple tours and pilgrimage journeys from Pune. Innova vehicles provide spacious seating and smooth highway travel suitable for families, senior citizens, and group darshan travel. Professional drivers ensure safe driving and punctual pickup services throughout the temple tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Innova temple cab reservations."
  },
  {
    name: "Sedan Pune Temple Taxi",
    description: "Sedan Pune temple taxi service provides affordable transportation for devotees planning spiritual journeys and temple visits from Pune. Sedan vehicles ensure reliable city and highway travel suitable for spiritual tourism, pilgrimage tours, and family darshan trips. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient sedan temple taxi reservations."
  },
  {
    name: "Pune Pilgrimage Cab Service",
    description: "Pune pilgrimage cab service offers premium transportation with comfortable vehicles and professional chauffeurs for religious tours and pilgrimage travel from Pune. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for spiritual tourism and family travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient pilgrimage cab reservations."
  },
  {
    name: "Pune Religious Sightseeing Cab",
    description: "Pune religious sightseeing cab service provides comfortable transportation for devotees planning same-day temple darshan and religious sightseeing tours from Pune. Vehicles ensure smooth and safe city and highway travel suitable for spiritual tourism, family travel, and temple visits. Professional chauffeurs ensure timely pickup and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient religious sightseeing cab reservations."
  },
  {
    name: "Pune Temple Travel Cab",
    description: "Pune temple travel cab service provides dependable transportation for passengers planning spiritual and temple tours from Pune. Comfortable vehicles ensure smooth travel suitable for pilgrimage tourism, educational tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient temple travel cab reservations."
  },
  {
    name: "Pune Spiritual Journey Cab",
    description: "Pune spiritual journey cab service provides reliable transportation for travelers and devotees planning spiritual journeys and temple tours around Pune. Comfortable vehicles ensure smooth and safe travel suitable for tourists, families, senior citizens, and pilgrimage groups. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient spiritual journey cab reservations."
  },
  {
    name: "Pune Temple Trip Taxi",
    description: "Pune temple trip taxi service offers comfortable transportation for passengers planning religious tours and temple visits from Pune to major pilgrimage destinations. Vehicles ensure reliable local and highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for spiritual tourism, temple darshan, and family pilgrimage travel. Flexible booking options allow convenient temple trip taxi reservations."
  }
],

tableData: [
  ["Pune Temple Tour Cab", "Pune Religious Tour Taxi"],
  ["Pune Temple Darshan Cab", "Pune Spiritual Tour Cab"],
  ["Pune Temple Sightseeing Taxi", "Best Pune Temple Cab"],
  ["Cheap Pune Temple Taxi", "SUV Pune Temple Tour Cab"],
  ["Innova Pune Temple Cab", "Sedan Pune Temple Taxi"],
  ["Pune Pilgrimage Cab Service", "Pune Religious Sightseeing Cab"],
  ["Pune Temple Travel Cab", "Pune Spiritual Journey Cab"],
  ["Pune Temple Trip Taxi", "Pune Temple Tour Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune Temple Tour Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune Temple Tour cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and peaceful pilgrimage travel."
      },
      {
        WhyChooseheading: "Affordable Temple Tour Taxi Packages",
        WhyChoosedescription: "Shivai Travels offers affordable Pune Temple Tour cab pricing with transparent fare details and no hidden charges. Customers receive complete temple tour package information before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Temple Tour Cab Availability",
        WhyChoosedescription: "Our Pune Temple Tour cab service operates 24 hours a day for temple visits, family pilgrimages, religious tours, darshan trips, and customized spiritual travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable travel experiences during temple tours."
      },
      {
        WhyChooseheading: "Customized Temple Tour Packages",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including Ashtavinayak tours, Jejuri Darshan, Shirdi trips, Tuljapur tours, Pandharpur Darshan, and customized temple travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for pilgrims, families, senior citizens, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Temple Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with temple routes across Maharashtra and ensure safe driving, smooth travel, and timely darshan for every pilgrimage journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune Temple Tour cab service?", answer: "Pune Temple Tour cab service provides comfortable taxi transportation for visiting famous temples and pilgrimage destinations near Pune and across Maharashtra." },
    { question: "Is Pune Temple Tour cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune Temple Tour cab service." },
    { question: "Which vehicles are available for temple tours?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book customized temple tour packages?", answer: "Yes, customers can book customized temple tour and pilgrimage travel packages according to their requirements." },
    { question: "Which temples are covered in Pune Temple Tour packages?", answer: "Shivai Travels covers destinations like Ashtavinayak temples, Shirdi, Jejuri, Tuljapur, Pandharpur, Bhimashankar, and other religious places." },
    { question: "Are all temple tour taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable pilgrimage travel." },
    { question: "Can I book Pune Temple Tour cab service online?", answer: "Yes, customers can easily book Pune Temple Tour cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group pilgrimage tours?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group pilgrimage travel." },
    { question: "Are Pune Temple Tour cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune Temple Tour cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and festive pilgrimage seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Suresh Patwardhan",
      feedback:
        "Booked Pune Temple Tour cab service with Shivai Travels. Comfortable vehicle, smooth pilgrimage travel, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Vaishali Kulkarni",
      feedback:
        "Excellent Pune Temple Tour taxi service. Affordable pricing, clean cab, and wonderful spiritual travel experience.",
      rating: 5
    }
  ];











  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Temple Tour Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-temple-tour-cab.jpg",
  "description": "Book Pune Temple Tour cab service for comfortable and peaceful religious travel. Shivai Travels offers customized temple darshan packages with sedan, SUV, Innova, and luxury cab options available 24x7 for Pune pilgrimage, spiritual journeys, and temple sightseeing tours.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹9/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-temple-tour-cab"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune Temple Tour Cab | Religious & Spiritual Taxi Service | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune Temple Tour cab service for religious and spiritual travel. Affordable temple darshan packages with sedan, SUV, Innova, and luxury cabs available 24x7 for Pune pilgrimage sites and sightseeing tours."
  />

  <meta
    name="keywords"
    content="pune temple tour cab, pune religious tour taxi, pune temple darshan cab, pune spiritual tour cab, pune temple sightseeing taxi, best pune temple cab, cheap pune temple taxi, suv pune temple tour cab, innova pune temple cab, sedan pune temple taxi, pune pilgrimage cab service, pune religious sightseeing cab, pune temple travel cab, pune spiritual journey cab, pune temple trip taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/65.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetempletourcab;